<template>
  <div class="quote-ask">
    <button v-if="!open && !done" type="button" class="ask" @click="open = true">报价咨询</button>
    <form v-else-if="!done" @submit.prevent="submit">
      <label>
        手机号
        <input v-model="phone" inputmode="numeric" maxlength="11" placeholder="用于报价联系" />
      </label>
      <button type="submit" :disabled="sending">{{ sending ? '提交中…' : '提交' }}</button>
      <button type="button" class="ghost" @click="open = false">取消</button>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
    <p v-else class="ok">已提交。我们会按 {{ phone }} 联系你。</p>
  </div>
</template>

<script>
import { createQuoteInquiry } from '../api/platformService'

export default {
  name: 'QuoteAsk',
  props: {
    kind: { type: String, required: true },
    summary: { type: String, default: '' },
    detail: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      open: false,
      done: false,
      sending: false,
      phone: '',
      error: ''
    }
  },
  methods: {
    async submit() {
      const phone = this.phone.replace(/\D/g, '')
      if (!/^1\d{10}$/.test(phone)) {
        this.error = '请填写 11 位手机号'
        return
      }
      this.sending = true
      this.error = ''
      try {
        await createQuoteInquiry({
          kind: this.kind,
          phone,
          summary: this.summary,
          detail: this.detail
        })
        this.phone = phone
        this.done = true
      } catch (err) {
        this.error = err.response?.data?.error || '提交失败'
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped>
.quote-ask { margin-top: 14px; }
.ask, form button {
  border: 0;
  background: #165dff;
  color: #fff;
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
}
form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
label { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #4e5969; }
input {
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  padding: 8px 12px;
  font: inherit;
  width: 160px;
}
input:focus { outline: none; border-color: #165dff; }
.ghost { background: #fff; color: #4e5969; border: 1px solid #e5e6eb; }
.error { width: 100%; margin: 0; color: #f53f3f; font-size: 13px; }
.ok { margin: 0; color: #188038; font-size: 13px; }
</style>
